import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { ImageIcon } from '../../theme/Icons';
import { AttachmentList } from '../generic-notes/attachments/AttachmentList';
import { createUseStyles } from 'react-jss';
import { isPlatform } from '../../utils/isPlatform';
import { LinkText } from '../../components/LinkText';

const useStyles = createUseStyles({
    attachmentArea: isPlatform('desktop') ? {
        '& hr': {
            width: '100%',
            marginBlockStart: -6
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    } : {
        minHeight: 70,
        '& hr': {
            marginBlockStart: -6
        }
    }
});

export const Attachments: FC<{ note: any; editHandler?: () => void; }> = ({ note, editHandler }) => {
    const classes = useStyles();

    // The recording's audio file is added to note.attachments on upload so it stays
    // downloadable. The Recording tab now exposes its own download affordance, so
    // we hide *only* that one attachment here. Any other attachments the user
    // adds (photos, PDFs, etc.) have distinct urls and pass through untouched.
    const recordingUrl = note.otherAttributes?.recording?.url;
    const visibleAttachments = recordingUrl
        ? note.attachments.filter((a: { url?: string }) => a.url !== recordingUrl)
        : note.attachments;

    if (!visibleAttachments.length && !editHandler) {
        return null;
    }

    return (
        <ViewNoteSection title="Attachments" Icon={ImageIcon}>
            {visibleAttachments.length > 0 ? (
                <div className={classes.attachmentArea}>
                    <AttachmentList
                        note={note}
                        attachments={visibleAttachments}
                        marginBottom={12}
                    />
                </div>
            ) : (
                <div>
                    {editHandler &&
                        <><LinkText data-type="edit-link" onClick={editHandler}>Edit</LinkText> to add relevant files, photos and more.</>
                    }
                </div>
            )}
        </ViewNoteSection>
    );
};
